"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalPreference = exports.preferenceCheck = exports.OpenSankeyDefaultModalePreferenceContent = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_2 = require("@chakra-ui/react");
const SankeyUtils_1 = require("../configmenus/SankeyUtils");
const SankeyMenuTop_1 = require("../topmenus/SankeyMenuTop");
const OpenSankeyDefaultModalePreferenceContent = (t, data, trad, ComponentUpdater) => {
    const ui = {
        'lang': react_1.default.createElement(react_bootstrap_1.InputGroup, { key: '1' },
            react_1.default.createElement(react_bootstrap_1.InputGroup.Text, null, t('Menu.lang')),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { size: 'sm', value: trad.language, onChange: (evt) => {
                    trad.changeLanguage((evt.target.value));
                } },
                react_1.default.createElement("option", { key: 'francais', value: 'fr' }, "Fran\u00E7ais"),
                react_1.default.createElement("option", { key: 'english', value: 'en' }, "English"))),
        'form': [
            react_1.default.createElement("h4", null, t('Menu.pref_title_sub_menu')),
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { key: '3' },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: (window.SankeyToolsStatic ? window.SankeyToolsStatic : false), onClick: () => {
                        sessionStorage.removeItem('modepref');
                        data.accordeonToShow = ['MEP'];
                        ComponentUpdater.updateComponentMenuConfig.current();
                    } }, "Mode Simple"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'dark', disabled: (window.SankeyToolsStatic ? window.SankeyToolsStatic : false), onClick: () => {
                        sessionStorage.setItem('modepref', 'expert');
                        data.accordeonToShow = ['MEP', 'EN', 'EF', 'ED', 'LL', 'Vis'];
                        ComponentUpdater.updateComponentMenuConfig.current();
                    } }, "Mode Expert")),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), isChecked: data.accordeonToShow.includes('MEP'), onChange: () => {
                        (0, exports.preferenceCheck)('MEP', data);
                        ComponentUpdater.updateComponentMenuConfig.current();
                    } }, t('Menu.MEP'))),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), isChecked: true, disabled: true }, t('Menu.Noeuds'))),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), isChecked: data.accordeonToShow.includes('EN'), onChange: () => {
                        (0, exports.preferenceCheck)('EN', data);
                        ComponentUpdater.updateComponentMenuConfig.current();
                    } }, t('Menu.EN'))),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), isChecked: true, disabled: true }, t('Menu.flux'))),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), isChecked: data.accordeonToShow.includes('EF'), onChange: () => {
                        (0, exports.preferenceCheck)('EF', data);
                        ComponentUpdater.updateComponentMenuConfig.current();
                    } }, t('Menu.EF'))),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), isChecked: data.accordeonToShow.includes('ED'), onChange: () => {
                        (0, exports.preferenceCheck)('ED', data);
                        ComponentUpdater.updateComponentMenuConfig.current();
                    } }, t('Menu.ED'))),
        ],
        'node_label_sep': react_1.default.createElement(SankeyUtils_1.OSTooltip, { label: t('Menu.tooltips.node_label_sep') },
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup.Text, null, t('Menu.node_label_sep')),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', value: data.node_label_separator, onChange: (evt) => {
                        data.node_label_separator = evt.target.value;
                        ComponentUpdater.updateComponentMenuConfig.current();
                    } }))),
    };
    return ui;
};
exports.OpenSankeyDefaultModalePreferenceContent = OpenSankeyDefaultModalePreferenceContent;
const preferenceCheck = (str, data) => {
    sessionStorage.removeItem('modepref');
    if (!data.accordeonToShow.includes(str)) {
        data.accordeonToShow.push(str);
    }
    else {
        const posElemt = data.accordeonToShow.indexOf(str);
        data.accordeonToShow.splice(posElemt, 1);
    }
};
exports.preferenceCheck = preferenceCheck;
const ModalPreference = ({ dict_hook_ref_setter_show_dialog_components, ui, t, pointer_pos }) => {
    const content = react_1.default.createElement(react_1.default.Fragment, null, Object.values(ui).map((d, i) => {
        return react_1.default.createElement(react_1.default.Fragment, { key: i }, d);
    }));
    return (0, SankeyMenuTop_1.MenuDraggable)(dict_hook_ref_setter_show_dialog_components, 'ref_setter_show_modal_preference', content, pointer_pos, t('Menu.title_pref'), 34);
};
exports.ModalPreference = ModalPreference;
